// import firebase from 'firebase';
import firebase from 'firebase/app';
// var config = {
//   apiKey: 'AIzaSyA6UNzVWcw-V4iWT4FaXpiPxNOwKled1hQ',
//   authDomain: 'd-critics.firebaseapp.com',
//   databaseURL: 'https://d-critics.firebaseio.com',
//   projectId: 'd-critics',
//   storageBucket: 'd-critics.appspot.com',
//   messagingSenderId: '971192714322'
// };

var config = {
  apiKey: 'AIzaSyBAWQvzWVWePEz4E8x1LemHqG9-muTb1Fw',
  authDomain: 'dcritics-list.firebaseapp.com',
  databaseURL: 'https://dcritics-list.firebaseio.com',
  projectId: 'dcritics-list'
};
var fire = firebase.initializeApp(config);
export default fire;



// WEBPACK FOOTER //
// ./src/fire.js